import "core-js/modules/es6.object.define-property";

var _ABTEST$ACCORDION$ANC;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This file provides node rules for structured-content JSON document
import { ABTEST, ACCORDION, ANCHORLINK, ANCHORLINKTARGET, APOLLOINTEGRATIONCANARY, AUTHLINK, AUTOINSURANCEENTRYPOINT, AUTOINSURANCEQUOTES, BACKTOTOPLINK, BUTTON, CALCULATION, CALCULATOR, CALCULATORCONDITIONAL, CALCULATORINPUT, CALCULATORRADIO, CALCULATORSELECT, COLUMNS, CONTAINER, CONTENTHEADING, CONTENTIMAGE, CONTENTQUOTE, DIVIDER, DROPCAPS, FAQ, HEADING, HLMENTRY, HOUSEAD, IBIPAINTEDDOORTEST, IMAGE, LINK, LIST, LISTITEM, MARKETPLACEAPPLYNOW, MARKETPLACECOMPARISONLINK, MARKETPLACECOMPARISONTABLE, MARKETPLACEFIELD, MARKETPLACEPARTNERPLACEMENT, MARKETPLACEPRODUCTCARD, MARKETPLACESTARRATING, MARKETPLACERATETABLE, MINIPRODUCTCARD, MORELINK, NERDTIP, OUTOFDATEMESSAGE, POSTLIST, PREQUALAPPLICATIONHOUSEAD, PRODUCTSTARRATING, RENDERCONTEXTCONDITIONAL, SCREENSIZECONDITIONAL, SPOTIFY, STARRATING, TABLE, TABLEOFCONTENTS, TYPE, VIDEO, USERSEGMENTCONDITIONAL, WPCALCULATOR, WPEMBED, WPHOUSEAD, WPPOSTLIST, WPTABLE, TABLEOFCONTENTSTARGET, MARKETPLACEENTITYDISPLAYNAME } from './types';
import migrateAccordionFrom_1_0_0_to_2_0_0 from './components/accordion/migrations/2.0.0';
export default (_ABTEST$ACCORDION$ANC = {}, _defineProperty(_ABTEST$ACCORDION$ANC, ABTEST, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, ACCORDION, {
  nodeProps: ['panels.*.children', 'panels.*.label', 'panels.*.labelCollapsed'],
  version: '2.0.0',
  migrations: {
    '2.0.0': migrateAccordionFrom_1_0_0_to_2_0_0
  }
}), _defineProperty(_ABTEST$ACCORDION$ANC, ANCHORLINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, ANCHORLINKTARGET, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, APOLLOINTEGRATIONCANARY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, AUTHLINK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, AUTOINSURANCEENTRYPOINT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, AUTOINSURANCEQUOTES, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, BACKTOTOPLINK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, BUTTON, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CALCULATION, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CALCULATOR, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CALCULATORCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CALCULATORINPUT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CALCULATORRADIO, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CALCULATORSELECT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, COLUMNS, {
  nodeProps: ['columns.*.children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CONTAINER, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CONTENTHEADING, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CONTENTIMAGE, {
  nodeProps: ['children', 'caption'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, CONTENTQUOTE, {
  nodeProps: ['children', 'author', 'authorTitle'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, DIVIDER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, DROPCAPS, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, FAQ, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, HEADING, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, HLMENTRY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, HOUSEAD, {
  nodeProps: ['ctaNode'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, IBIPAINTEDDOORTEST, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, IMAGE, {
  nodeProps: ['children', 'caption'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, LINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, LIST, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, LISTITEM, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MARKETPLACEAPPLYNOW, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MARKETPLACECOMPARISONLINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MARKETPLACECOMPARISONTABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MARKETPLACEENTITYDISPLAYNAME, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MARKETPLACEFIELD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MARKETPLACEPARTNERPLACEMENT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MARKETPLACEPRODUCTCARD, {
  nodeProps: ['bottomLine'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MARKETPLACESTARRATING, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MARKETPLACERATETABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MINIPRODUCTCARD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, MORELINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, NERDTIP, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, OUTOFDATEMESSAGE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, POSTLIST, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, PREQUALAPPLICATIONHOUSEAD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, PRODUCTSTARRATING, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, RENDERCONTEXTCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, SCREENSIZECONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, SPOTIFY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, STARRATING, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, TABLE, {
  nodeProps: ['columns.*.heading', 'data.*.cells.*'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, TABLEOFCONTENTS, {
  nodeProps: ['items.*.title'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, TABLEOFCONTENTSTARGET, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, TYPE, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, VIDEO, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, USERSEGMENTCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, WPCALCULATOR, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, WPEMBED, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, WPHOUSEAD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, WPPOSTLIST, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ANC, WPTABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _ABTEST$ACCORDION$ANC);